import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Initials, SecondaryTextXs300, Icon, BoldMatchText, ProfileImage } from 'atoms';
import { GreenTickSvg } from 'components/icons';
import { boldMatchCharacters } from 'utils';
import { GenericWrapper } from 'wrappers';
import { getInitials } from 'utils/getInitials';
import { Mr2, Mr3, FlexCenterJustifyCenterWrapper } from "wrappers";

const template = styled.div`
  ${({ theme, displayState }) => css`
    width: 100%;
    padding: 6px 8px;
    color: ${theme?.colour?.secondary};

    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: space-between;

    ${displayState?.isSelected && css`
      background: ${`${theme?.colour?.primary}0D`};
    `}

    &:hover {
      background: ${`${theme?.colour?.primary}0D`};
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  displayState: ({ option }) => option,
  atoms: [
    {
      wrapper: FlexCenterJustifyCenterWrapper,
      name: "Wrapper",
      atoms: [
        {
          wrapper: GenericWrapper,
          name: 'TextWrapper',
          atoms: [
            {
              component: wrap(Initials, Mr2),
              name: 'Initials',
              renderIf: ({ showAvatar, personSelector, option }) => !!showAvatar && !!personSelector && !option?.image,
              displayValue: ({ option }) => getInitials(option.name ?? ""),
            },
            {
              component: wrap(ProfileImage, Mr2),
              name: 'Image',
              renderIf: ({ showAvatar, personSelector, option }) => !!showAvatar && !!personSelector && !!option?.image,
              displayValue: ({ option }) => option?.image ?? "",
              displayState: ({ }) => ({ size: 30 })
            },
          ]
        },
        {
          component: BoldMatchText,
          name: 'Text',
          displayValue: ({ option, searchTerm }) => boldMatchCharacters({ text: option.display, match: searchTerm })
        },
        {
          component: SecondaryTextXs300,
          name: 'Subtitle',
          renderIf: ({ option }) => !!option.subtitle,
          displayValue: ({ option }) => option.subtitle
        },
      ]
    },
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ option, selectedOptionIds }) => selectedOptionIds.includes(option.id),
      displayValue: ({ }) => GreenTickSvg({})
    }
  ],
})